import { ScheduleRightBar } from "slot-definitions"
import { RightBarTabs } from "routes/schedule/plugins/right-bar/right-bar-tabs"
import { RightBarTabsForPdf } from "routes/schedule/plugins/right-bar/right-bar-tabs-for-pdf"

ScheduleRightBar.plug(<RightBarTabs $lazy priority={200} if={(c) => !c.isPDF} />)
ScheduleRightBar.plug(<RightBarTabsForPdf $lazy priority={200} if={(c) => !!c.isPDF} />)
